<template>
    <van-row>
        <van-col span="24">
            <van-contact-card
                    type="edit"
                    name="张三"
                    tel="13000000000"
                    :editable="false"
            />
        </van-col>
    </van-row>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>
